import CardBlockView from './View';
import CardBlockEdit from './Edit';
import { CardSchema } from './schema';
import cardSVG from '@plone/volto/icons/grid.svg';
import type { BlockConfigBase } from '@plone/types';
export interface CardBlockData {
  text?: string;
  icon_selector?: string;
  href?: Array<{ '@id': string; title?: string }>;
  external_link?: string;
  openLinkInNewPage?: boolean;
  theme?: string;
  backgroundColor?: string;
  styles?: any;
}

const CardBlockInfo: BlockConfigBase = {
  id: 'cardBlock',
  title: 'Ícone e Texto',
  icon: cardSVG,
  group: 'common',
  view: CardBlockView,
  edit: CardBlockEdit,
  blockSchema: CardSchema,
  restricted: false,
  mostUsed: false,
  sidebarTab: 1,
  blockHasOwnFocusManagement: false,
};

export default CardBlockInfo;
